// extracted by mini-css-extract-plugin
export default {"card6":"bpkThBkh","image":"ocWVbujP","content":"Rs8Wmgpp","link":"MeSXSX2B","altheadline":"iNRpi0Mo"};